import * as actionTypes from '../constants/actionTypes';
export function enterAnnotationMode(nextCommentUUID, nextReference) {
    return {
        type: actionTypes.ENTER_ANNOTATION_MODE,
        nextCommentUUID: nextCommentUUID,
        nextReference: nextReference,
    };
}
export function leaveAnnotationMode() {
    return {
        type: actionTypes.LEAVE_ANNOTATION_MODE,
    };
}
export function cancelCurrentAnnotation() {
    return {
        type: actionTypes.CANCEL_ANNOTATION,
    };
}
export function addNewAnnotation(screenArea, offset) {
    return {
        type: actionTypes.ADD_NEW_ANNOTATION,
        screenArea: screenArea,
        offset: offset,
    };
}
export function removeAnnotation(commentUUID) {
    return {
        type: actionTypes.REMOVE_ANNOTATION,
        commentUUID: commentUUID,
    };
}
export function addAnnotation(annotation) {
    return {
        type: actionTypes.ADD_ANNOTATION,
        annotation: annotation,
    };
}
export function positionAnnotation(commentUUID, toScreenArea, offset) {
    return {
        type: actionTypes.POSITION_ANNOTATION,
        commentUUID: commentUUID,
        toScreenArea: toScreenArea,
        offset: offset,
    };
}
export function scrollToAnnotation(commentUUID) {
    // TODO move to saga
    return function (dispatch) {
        dispatch({
            type: actionTypes.SCROLL_TO_ANNOTATION,
            commentUUID: commentUUID,
        });
        setTimeout(function () { return dispatch(pulseAnnotation()); }, 0);
    };
}
function pulseAnnotation() {
    return {
        type: actionTypes.PULSE_ANNOTATION,
    };
}
export function clearAnnotations() {
    return {
        type: actionTypes.CLEAR_ANNOTATIONS,
    };
}
export function highlightAnnotation(commentUUID) {
    return {
        type: actionTypes.HIGHLIGHT_ANNOTATION,
        commentUUID: commentUUID,
    };
}
export function unhighlightAnnotation(commentUUID) {
    return {
        type: actionTypes.UNHIGHLIGHT_ANNOTATION,
        commentUUID: commentUUID,
    };
}
export function makeAnnotationMoveable(commentUUID) {
    return {
        type: actionTypes.MAKE_ANNOTATION_MOVEABLE,
        commentUUID: commentUUID,
    };
}
export function markAnnotationSaved(commentUUID) {
    return {
        type: actionTypes.MARK_ANNOTATION_SAVED,
        commentUUID: commentUUID,
    };
}
export function annotationCommentUpdated(commentUUID, isDone) {
    return {
        type: actionTypes.ANNOTATION_COMMENT_UPDATED,
        commentUUID: commentUUID,
        isDone: isDone,
    };
}
export function updateAnnotation(commentUUID, annotation) {
    return {
        type: actionTypes.UPDATE_ANNOTATION,
        commentUUID: commentUUID,
        annotation: annotation,
    };
}
